import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ContextMenuComponent} from 'ngx-contextmenu';
import {IMessengerConnector, Message} from '../../../../types/all.type';
import {InterfaceService} from '../../../../services/interface.service';

@Component({
  selector: 'app-demo-message-sender',
  templateUrl: './demo-message-sender.component.html',
  styleUrls: ['./demo-message-sender.component.scss']
})
export class DemoMessageSenderComponent implements OnInit {
  @Input() message: Message = {
    chat_id: undefined,
    color: '',
    compact: false,
    component: '',
    date: 0,
    date_format: '',
    delete: false,
    deleted: false,
    edit_date: 0,
    effect: false,
    empty: false,
    id: undefined,
    is_creator: false,
    load: false,
    new_chat_title: '',
    online: false,
    out: false,
    parsed_count: 0,
    prev_user: false,
    read: false,
    replace: false,
    reply_to_messages: [],
    select: false,
    sender: {
      id: 0,
      completed: false,
      pause: false,
      text: 'Ознакомительная рассылка, добавьте свою первую в форме ниже.',
      name: '',
      start_date: '2023-01-31T17:37:51+03:00',
      attachments: null,
      end_date: '2023-01-31T19:20:10.012759+03:00',
      total_send: 42,
      current_count: 30,
      error_count: 1,
      contacts: '',
      account_id: 886,
      loop_interval: 0,
      loop_need_count: 0,
      loop_count: 0,
      last_error: '',
      contacts_fatal: '{"https://t.me/bphubspot": "JOIN_NOT_HELP"}',
      all_error_count: 1,
      error_join_count: 1,
      join_count: 10,
      type: 0,
      parsed_status: null,
      parsed_members_count: 0,
      parsed_count: 0,
      parsed_chat: '',
      parsed_completed: null,
      post_link: ''
    },
    service: 'sender',
    service_class: 'sender',
    show: true,
    text: '',
    text_list: '',
    time: 0,

  };
  @Input() Service: IMessengerConnector;
  @Input() contextMenu: ContextMenuComponent;

  constructor(
    public interfaceService: InterfaceService,
  ) {
  }

  ngOnInit(): void {
  }

}
